const defaults = {
  COMPANY_NAME: "Best Coast Pairings",
  APP_NAME: "BCP",
  LABEL_GAMESYSTEM: "Game System",
  SITE_NAME: "Best Coast Pairings",
  SITE_DESCRIPTION: "Best Coast Pairings: Competitive events, made easier",
  GAMESYSTEM_IMAGE_W: 6,
  GAMESYSTEM_IMAGE_H: 1,
  SOCIALS: "{}",
  SYSTEM_IMAGES_CLOUDFRONT: "",
  SUPPORTS_EVENT_FORMAT_LABEL: "Format",
  STYLESHEET: "stylesheet1",
  HEADER_SOLFORGE_URL: "",

  MANUFACTURER_GW: "Games Workshop",
};

export function getEnvironmentVariable(suffix) {
  let value = undefined;
  if (window.location?.hostname === "localhost") {
    value = process.env[`REACT_APP_LOCAL_${suffix}`];
    if (value === "NOT SET") {
      value = undefined;
    } else if (value !== undefined) {
      return suffix === "API" ? value?.replace("/v1", "") : value;
    }
  }

  value = process.env[`REACT_APP_${suffix}`];
  if (value === undefined || value === "NOT SET") {
    return defaults[suffix];
  }

  return suffix === "API" ? value?.replace("/v1", "") : value;
}
